import { ConditionType } from '../condition-type';
import { BitConditionModel } from '../bit/bit-condition-model';
import { WordConditionModel } from '../word/word-condition-model';
var ConditionHelper = /** @class */ (function () {
    function ConditionHelper() {
    }
    ConditionHelper.setPrototypeOf = function (object, prototype) {
        var constructor = function () {
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    (function (_key) {
                        Object.defineProperty(this, _key, {
                            get: function () {
                                return object[_key];
                            },
                            set: function (value) {
                                object[_key] = value;
                            },
                            enumerable: true
                        });
                    }).call(this, key);
                }
            }
        };
        constructor.prototype = prototype;
        return new constructor;
    };
    ConditionHelper.getConditionType = function (record) {
        var condition = record.condition;
        if (condition instanceof BitConditionModel) {
            return ConditionType.Bit;
        }
        else if (condition instanceof WordConditionModel) {
            return ConditionType.Word;
        }
    };
    return ConditionHelper;
}());
export { ConditionHelper };
